import React from 'react';
import PropTypes from 'prop-types';

function HeaderBoxWidget (props) {
    return (
        <div className="col-12 text-center">
            <h1 data-test-id="header-title" className="text-color-changeable mb-12">{props?.title}</h1>
            <p data-test-id="header-description" className="text-white text-sm-medium">{(props?.description && !props?.descriptions) ? props.description : props?.descriptions}</p>
        </div>
    )
}

HeaderBoxWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string
}

export default HeaderBoxWidget;
